import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { List } from 'immutable';
import { storeWithExpiration } from '../../utils/common';
import { enableDatasetVersion, fetchDatasetsById, fetchVersions } from '../../actions/data';

import Datasets from './Datasets';

export class DatasetsContainer extends React.Component {
  static propTypes = {
    account: PropTypes.object.isRequired,
    dataSets: PropTypes.object.isRequired,
    enableVersionAction: PropTypes.func.isRequired,
    fetchDatasetsByIdAction: PropTypes.func.isRequired,
    fetchVersionsAction: PropTypes.func.isRequired,
  };

  componentWillMount = () => {
    const { account, fetchDatasetsByIdAction } = this.props;
    const token = storeWithExpiration.get('token');

    fetchDatasetsByIdAction(account.id, token);
  };

  performEnableVersion = (datasetId, versionId) => {
    const { enableVersionAction, fetchVersionsAction } = this.props;
    const token = storeWithExpiration.get('token');
    const prom = new Promise(resolve => {
      enableVersionAction(token, datasetId, versionId, resolve);
    });
    prom.then(() => {
      fetchVersionsAction(datasetId, token);
    });
  };

  render() {
    const { dataSets } = this.props;

    // for consistency between data index and admin view
    const dataSetsList = new List(dataSets.valueSeq().map(set => set));

    return (
      <div>
        <Datasets dataSets={dataSetsList} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { account, data } = state;
  const dataSets = data.get('dataSets');
  return {
    account,
    dataSets,
  };
};

export default connect(mapStateToProps, {
  fetchDatasetsByIdAction: fetchDatasetsById,
  fetchVersionsAction: fetchVersions,
  enableVersionAction: enableDatasetVersion,
})(DatasetsContainer);
